import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Button } from "../../components/common/Button/Button";
import { mainAxiosInstance } from "../../services/service";
import { ServiceConfig } from "../../services/service-constants";
import { addRootCausePayload } from "../../store/rootCauseAnalysis/actions";
import LottieLoad from "../../components/common/ErrorComponents/LottieLoad";
import Feedback from "../../components/common/ErrorComponents/Feedback";
import NotAuthorized from "../../components/common/ErrorComponents/NotAuthorized";
import "./index.scss";
import Breadcrumbs from "../../components/common/Breadcrumb/Breadcrumbs";
import routes from "../../utils/constants";

const RootCauseAnalysis = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notAuthorized, setNotAuthorized] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const vinNumber = useSelector((state) => state.mainReducer.vin_Number);
  const location = useLocation();
  let rcaPayload = useSelector(
    (state) => state.rootCauseReducer.rootCauseAnalysisPayload
  );
  if (rcaPayload && rcaPayload !== {}) {
    window.localStorage.setItem(
      "root-cause-payload",
      JSON.stringify(rcaPayload)
    );
  } else {
    rcaPayload = JSON.parse(
      window.localStorage.getItem("root-cause-payload") || {}
    );
    dispatch(addRootCausePayload({ ...rcaPayload }));
  }
  const [RCAdata, setRCAdata] = useState(null);
  const [noDataFound, setNoDataFound] = useState(true);

  const getRCAdata = (vin, oId, dcode, stats) => {
    let url = `${ServiceConfig.mod_root_cause_analysis}`;
    let params = {
      vin_number: vinNumber,
      organization_id: oId,
      stats_date: stats,
      dtc_code: dcode,
    };
    mainAxiosInstance
      .get(url, { params: params })
      .then((response) => {
        if (response.status === 200) {
          setRCAdata(response.data);
          setNoDataFound(false);
        }
        if (response.status === 401) {
          setErrorMsg(response.data.detail || "You are not authorized");
          setNotAuthorized(true);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setNotAuthorized(true);
          setErrorMsg(err.response.data?.details || "You are not authorized.");
        } else {
          setApiError(true);
          setErrorMsg(err.response.data.details || "No records Found");
        }
      });
  };
  useEffect(() => {
    if (
      rcaPayload.vin &&
      rcaPayload.oId &&
      rcaPayload.dcode &&
      rcaPayload.stats
    ) {
      getRCAdata(
        rcaPayload.vin,
        rcaPayload.oId,
        rcaPayload.dcode,
        rcaPayload.stats
      );
    }
  }, []);

  const goToRootCauseData = () => {
    navigate("./root-cause-data", { relative: "route" });
  };

  const goToPrescribedActions = () => {
    navigate("./prescribed-actions", { relative: "route" });
  };

  if (notAuthorized) {
    return <NotAuthorized title={errorMsg} />;
  }
  if (apiError) {
    return <Feedback />;
  }
  if (!RCAdata) {
    return <LottieLoad />;
  }

  return (
    <>
      {!noDataFound && (
        <div className="rca__container">
          {window.location.pathname ===
          "/fault-analytics/root-cause-analysis" ? (
            <div className="" style={{ position: "relative", right: "11px" }}>
              <Breadcrumbs routes={routes} />
            </div>
          ) : (
            <></>
          )}
          <div className="rca--title">
            <p>
              Root Cause Identified - Air Leak detected at MAF Sensor Upstream
            </p>
          </div>
          <div className="rca--content">
            {RCAdata.map((rca, index) => {
              return (
                <div className="key-value-holder" id={rca.id} key={rca.id}>
                  <div className="key-name">
                    {location.pathname.includes("/diagnostics")
                      ? rca.paramName
                      : rca.paramName.replace("Triggering", "")}
                    <span>*</span>
                  </div>
                  <div className="value-details">
                    {rca.paramValue ? rca.paramValue : 0}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="rca--footer">
            <Button
              title="Prescribed Actions​"
              handleClick={() => {
                goToPrescribedActions();
              }}
              styleClasses={"btn btn-secondary-blue"}
            />
            <Button
              title="Root Cause Data​"
              handleClick={() => goToRootCauseData()}
              styleClasses={"btn btn-primary-blue"}
            />
          </div>
        </div>
      )}
      {noDataFound && (
        <div className="no-data">Sorry, We could not find any data.</div>
      )}
    </>
  );
};

export default RootCauseAnalysis;
